module.exports = __webpack_public_path__ + "img/marketing_tiny.1ef9fde9.png";